import React from "react";
import {useNavigate, useRouteError} from "react-router-dom";
import { Button } from "semantic-ui-react";
import "./error.css";


export default function Error(): JSX.Element {
  const error = useRouteError() as any;
  const navigate = useNavigate();

  return (
    <div className="error">
      <h1>Oops!</h1>
      <p>Entschuldigung, es ist ein unerwarteter Fehler aufgetreten!</p>
      <p>
          <i>{error.statusText || error.message}</i>
      </p>
      <p>
        <Button
          type="button"
          onClick={() => {
            navigate(-1);
          }}
        >
          Zurück
        </Button>
      </p>
    </div>
  );
}
